import { createEntityFilterStore } from "./createEntityFilterStore";
import type { ProjectFilterState } from "@/domain/types";

const buildInitialFilters = (): ProjectFilterState => ({
  search: "",
  beneficiary: "",
  subtype: "",
  status: "",
  documentation: "",
  fiscal_year: `${new Date().getFullYear()}`,
  fiscal_quota_uuid: "",
  sort: { key: undefined, direction: null },
});

export const useProjectFiltersStore = createEntityFilterStore<ProjectFilterState>(
  "ProjectFiltersStore",
  buildInitialFilters,
);
